import { Pipe, PipeTransform } from '@angular/core';
import { BillingStrategy } from '@galaxy/billing';
import { strategyForDisplay } from '../strategy';

/*
 * Formats the billing strategy to display
 *
 * Usage:
 *   {{ {strategy} | billingStrategy }}
 * Example:
 *   {{ BillingStrategy.EndOfPeriod | billingStrategy }}
 *   formats to: 'End of Period'
 */
@Pipe({ name: 'billingStrategy' })
export class BillingStrategyPipe implements PipeTransform {
  transform(bs: BillingStrategy): string {
    return strategyForDisplay(bs);
  }
}
